import { ThemeIcon, NavLink } from '@mantine/core';
import { IconList } from '@tabler/icons';
import { useSelector } from 'react-redux';
import { UserRole, UserType } from '../../../models/user';
import { RootState } from '../../../providers/store';
import { AppRoutePaths } from '../../../utils/enums';

interface OrdersLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function OrdersLink({ navigate, themeColor }: OrdersLinkProps) {
  const { user } = useSelector((state: RootState) => state.auth);

  const amelioCompany: number[] = [7, 45, 887, 2339];

  const canShow =
    user && (user.role !== UserRole.COMPANY || amelioCompany.includes(user.id));

  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="Pedidos"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="orange" variant="light">
          <IconList size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Andamento"
        onClick={() => navigate(AppRoutePaths.ORDERS)}
      />
      <NavLink
        label="Histórico"
        onClick={() => navigate(AppRoutePaths.ORDER_HISTORIC)}
      />

      {user?.role && ![UserRole.SAC, UserRole.SCREEN].includes(user?.role) && (
        <>
          {/* Tela de comprovantes antiga para FINANCEIRO 
          {user?.role === UserRole.FINANCIAL && (
            <NavLink
              label="Comprovantes"
              onClick={() => navigate(AppRoutePaths.ORDER_FILE_RECEIPTS_APPROVAL)}
            />
          )}
          */}

          {user?.role &&
            [UserRole.VENDOR, UserRole.OTHER, UserRole.FINANCIAL].includes(
              user?.role,
            ) && (
              <NavLink
                label="Pendência Financeira"
                onClick={() => navigate(AppRoutePaths.ORDERS_LATE)}
              />
            )}
          {user?.role !== UserRole.COMPANY && (
            <>
              <NavLink
                label="Primeiros Contatos"
                onClick={() => navigate(AppRoutePaths.ORDERS_FIRST_CONTACT)}
              />
              <NavLink
                label="PCP"
                onClick={() => navigate(AppRoutePaths.ORDER_PCP)}
              />
            </>
          )}
          {user?.role && [UserRole.VENDOR].includes(user?.role) && (
            <>
              <NavLink
                label="Primeira Peça"
                onClick={() => navigate(AppRoutePaths.ORDERS_FIRST_PIECE)}
              />
            </>
          )}

          {user?.type && [UserType.MASTER].includes(user?.type) && (
            <>
              <NavLink
                label="Solicitações"
                onClick={() => navigate(AppRoutePaths.ORDER_APPROVALS)}
              />
              <NavLink
                label="Orçamentos"
                onClick={() => navigate(AppRoutePaths.BUDGET_LIST)}
              />
              <NavLink
                label="Transferências"
                onClick={() => navigate(AppRoutePaths.ORDER_TRANSFER)}
              />
            </>
          )}

          {user?.role && [UserRole.RECEPTIONIST].includes(user?.role) && (
            <NavLink
              label="Transferências"
              onClick={() => navigate(AppRoutePaths.ORDER_TRANSFER)}
            />
          )}

          <NavLink
            label="Retirada de Pedidos"
            onClick={() => navigate(AppRoutePaths.ORDER_WITHDRAWAL)}
          />
        </>
      )}
      {canShow && (
        <>
          <NavLink
            label="XBZ"
            onClick={() => navigate(AppRoutePaths.ORDERS_XBZ)}
          />
        </>
      )}
    </NavLink>
  );
}
